<template>
  <div class="list shad">
    <div v-if="user == null" style="height:100%">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div>
          <!-- Pub: {{ publish }} -->
          <share-bar 
            v-if="published && publish" 
            :shareUrl="'https://cabinetmaps.com/shared/' + username + '/' + publicId"
            :twitterShareMessage="title + ', a shared map by ' + username + ' on @CabinetMaps @Blockstack'"
            ></share-bar>
        </div>
        <div></div>
        <div style="text-align:right">
          <b-form-checkbox v-model="publish" name="check-button" switch>
            Publish
          </b-form-checkbox>
          <div v-if="published">
            <!-- <a :href="getPublicLink" target="_blank">Public Link</a> -->
            <b-link :to="'../shared/' + username + '/' + publicId" target="_blank">Public Link</b-link>
          </div>
        </div>
      </div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <editable-title 
          v-model.trim="title"
          style="width:100%"
          >
        </editable-title>
      </div>
      <!-- pk.eyJ1Ijoic2hvbmdvbG9sbyIsImEiOiJjazBkdDQ1bW0wYXEyM2RyejB4eW02a2xwIn0.IzZDyzAlR1sHwDvnEv7ouw access token from cityseer --> 
      <!-- pk.eyJ1Ijoic2hvbmdvbG9sbyIsImEiOiJjazBkdDQ1bW0wYXEyM2RyejB4eW02a2xwIn0.IzZDyzAlR1sHwDvnEv7ouw access token from old cabinet dev --> 

      <!-- <div style="background:whitesmoke;min-height:300px;border-radius:15px" class="mb-5">
        <vue-mapbox-map id='map-container'
          :access-token='accessToken'
          :interactive='true'
          :geocoder='false'
          :lng='mapInfo.config.longitude'
          :lat='mapInfo.config.latitude'
          :zoom='mapInfo.config.zoom'
          :pitch='mapInfo.config.pitch ? mapInfo.config.pitch : 0'
          @mapbox-ready='setMap'
        ></vue-mapbox-map>
      </div> -->

      <!-- <div v-if='map'>
        <vue-mapbox-feature
          :map='map'
          :uid='"circle-example"'
          :layer-type='"circle"'
          :feature='pointGeom'
          :paint='circlePaint'
          :pulse='true'
        ></vue-mapbox-feature>
      </div> -->

      <MglMap 
        style="width:100%;min-height:300px;"
        class="mb-5"
        :accessToken="accessToken" 
        :mapStyle.sync="mapStyle" 
        :center.sync="mapCenter"
        :zoom.sync="mapInfo.config.zoom"
        @load="onMapLoaded"
      >
        <MglNavigationControl position="top-right"/>
        <MglGeolocateControl position="top-right" />

        <MglMarker
          v-for="(pm, index) in this.items" :key="pm.id"
          color="black"
          size="small"
          :coordinates="[pm.longitude, pm.latitude]"
          :offset="[0,0]"
        >
          <div slot="marker" style="background:black;color:white;width:30px;height:30px;border-radius:15px;padding:4px;text-align:center;font-size:1.5em" >
            <strong>{{ String.fromCharCode(index + 97).toUpperCase() }}</strong>
          </div>
          <MglPopup 
            :coordinates="[pm.longitude, pm.latitude]" 
            anchor="left" 
            :showed="false" 
            :offset="[10,0]" 
            :closeButton="false" 
            :closeOnClick="false"
          >
            <span><strong>{{ pm.title }}</strong></span>
          </MglPopup>
        </MglMarker>
      </MglMap>

      <b-card class="mb-5" no-body>
        <b-card-header>Configure Map (Drag to recenter)</b-card-header>
        <b-container fluid>
          <b-row class="mt-3 mb-2">
            <b-col sm="3">
              <label class="mt-2" for="longitudeBox">Longitude</label>
            </b-col>
            <b-col sm="9">
              <b-form-input id="longitudeBox" type="number" v-model="mapInfo.config.longitude" step="0.05"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col sm="3">
              <label class="mt-2" for="latitudeBox">Latitude</label>
            </b-col>
            <b-col sm="9">
              <b-form-input id="latitudeBox" type="number" v-model="mapInfo.config.latitude" step="0.05"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-2">
            <b-col sm="3">
              <label for="range-1">Zoom Level</label>
            </b-col>
            <b-col sm="9">
              <b-form-input id="range-1" v-model="mapInfo.config.zoom" type="range" min="0" max="15" step="0.1"></b-form-input>
            </b-col>
          </b-row>
        </b-container>
      </b-card>

      <h4 class="mb-4">Placemarks</h4>
      <div v-for="(item, index) in items" :key="item.id" class="mb-4">
        <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center">
          <!-- <code-editor 
            :value="item.value" 
            :index="index"
            @input="updateItem(index, $event)"
            @item-focus="setItemFocus(index)"
            @item-blur="setItemBlur(index)"
            @delete-item="deleteItem(index)"
            style="width:100%"
          ></code-editor> -->
          <placemark-editor 
            :placemarkData="item"
            style="width:100%">
          </placemark-editor>
          <transition name="fade">
            <!-- <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="item.editState === 'focus'"> -->
          <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="true">
            <font-awesome-icon 
              :icon="['far', 'minus-circle']" 
              style="font-size:30;cursor:pointer" 
            />
          </button>
          </transition>
        </div>
      </div>
      <!-- </ul> -->
      <b-container class="mt-4 mb-4">
        <b-row>
          <b-col><div class="mb-2 p-2 addbutton"  @click="addNewItem"><font-awesome-icon :icon="['far', 'plus-circle']" style="font-size:30" /></div></b-col>
        </b-row>
      </b-container>
      <h4 class="mb-4">Notes</h4>
      <div class="notebox" style="">
        <note-editor :value="{ noteId: id, note: note}" @input="updateNote($event)" />
      </div>
      
      <!-- <div class="mt-5">
          <pre>{{ listData }}</pre>
      </div>
      <div class="mt-5">
          <pre>{{ mapboxPlacemarks }}</pre>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex'
import NoteEditor from '@/components/NoteEditor'
import EditableTitle from '@/components/EditableTitle'
import SingleLineInput from '@/components/SingleLineInput'
import { Person } from "blockstack";
import { userSession } from "../userSession";
import { EventBus } from '@/event-bus';
import store from '@/store/store'
import NProgress from 'nprogress'
import { setTimeout } from 'timers';
import CodeEditor from '@/components/CodeEditor'

// import Mapbox from "mapbox-gl";
// import { MglMap } from "vue-mapbox";
import Mapbox from "mapbox-gl"
import { 
  MglMap, 
  MglNavigationControl, 
  MglGeolocateControl,
  MglPopup,
  MglMarker,
  MglScaleControl
} from "vue-mapbox"

import VueMapboxMap from 'vue-mapbox-map'
import VueMapboxFeature from 'vue-mapbox-feature'
// import bikeShelters from '@/assets/bikeShelters.js'
import * as turf from '@turf/turf'

import PlacemarkEditor from '@/components/PlacemarkEditor'
import ShareBar from '@/components/ShareBar'

export default {
  data() {
    return {
      computing: false,
      map: null,
      accessToken: 'pk.eyJ1Ijoic2hvbmdvbG9sbyIsImEiOiJjazBkdDQ1bW0wYXEyM2RyejB4eW02a2xwIn0.IzZDyzAlR1sHwDvnEv7ouw',
      lng: -73.99397182589848,
      lat: 40.687436325313655,
      zoom: 10.2,
      pitch: 0,
      baseBuffer: 0,
      buffer: 0,
      circlePaint: {
        'circle-radius': 5,
        'circle-color': '#29434e',
        'circle-opacity': 0.5,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#29434e',
        'circle-stroke-opacity': 0.8
      },
      linePaint: {
        'line-opacity': 1,
        'line-color': '#29434e',
        'line-width': 4,
        'line-dasharray': [1, 2],
        'line-blur': 0
      },
      fillPaint: {
        'fill-opacity': 0.2,
        'fill-color': '#a00037',
      },
      mapStyle: 'mapbox://styles/mapbox/light-v10',
      popupCoordinates: [-73.98604593990484, 40.73283788336977]
    };
  },
  computed: {
    mapCenter: {
      get: function () {
        return [this.mapInfo.config.longitude, this.mapInfo.config.latitude]
      },
      set: function (newValue) {
        // console.log('newValue: ', newValue)
        this.mapInfo.config.longitude = newValue.lng
        this.mapInfo.config.latitude = newValue.lat
      }
    },
    // fullName: {
    //   // getter
    //   get: function () {
    //     return this.firstName + ' ' + this.lastName
    //   },
    //   // setter
    //   set: function (newValue) {
    //     var names = newValue.split(' ')
    //     this.firstName = names[0]
    //     this.lastName = names[names.length - 1]
    //   }
    // },
    mapboxPlacemarks() {
      var myPlacemarks = {}
      myPlacemarks.type = "FeatureCollection"
      myPlacemarks.features = []
      this.items.forEach(pm => {
        myPlacemarks.features.push({
          "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [pm.longitude, pm.latitude]
            },
            "properties": {
              "title": pm.title,
              "description": pm.description
            }
        })
      })
      return myPlacemarks
    },
    centreGeom () {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          // coordinates: [this.lng, this.lat]
          coordinates: [this.mapInfo.config.longitude, this.mapInfo.config.latitude]
        }
      }
    },
    pointGeom () {
      // return this.bikeShelters
      return this.mapboxPlacemarks
    },
    // lineGeom () {
    //   return turf.polygonToLine(this.polyGeom)
    // },
    // polyGeom () {
    //   let c = turf.concave(this.pointGeom)
    //   return turf.buffer(c, -this.buffer)
    // },
    ...mapFields([
      'listData',
      'listData.id',
      'listData.title',
      'listData.type',
      'listData.showNote',
      'listData.note',
      'listData.createdAt',
      'listData.publish',
      'listData.publicId',
      'listData.published',
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username',
      'listData.mapInfo'
    ]),
    ...mapMultiRowFields(['listData.items']),
    ...mapGetters(['listsCount']),
    needsSave () {
      return this.$store.getters.needsSave
    },
    needsSave_currentList () {
      return this.$store.getters.needsSave_currentList
    },
    needsSave_lists () {
      return this.$store.getters.needsSave_lists
    },
  },
  created() {

    this.$store.dispatch('setUserSession')
    EventBus.$on('new-clicked', this.new);
    EventBus.$on('save-clicked', this.save);
    EventBus.$on('print-clicked', this.print);
    // EventBus.$on('menu-clicked', this.showNewNote);
    EventBus.$on('delete-clicked', this.delete);
    EventBus.$on('switch-list', this.switchList);

    this.mapbox = Mapbox
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
     window.addEventListener('scroll', this.handleScroll)
    // console.log("[List] mounted - checking for blockstack")
    // this.$store.dispatch('checkAndFinishSignIn')

    if (this.userSession.isUserSignedIn()) {
      // console.log("user is signed in");
      this.$store.dispatch('setUserProperties').then(() => {
        this.$store.dispatch('loadLists')
      })
      
    } else if (userSession.isSignInPending()) {
      // console.log("signinpending")
      this.userSession.handlePendingSignIn().then(userData => {
        // console.log("user pending log in finished");
        this.$store.dispatch('loadLists')
        window.location = window.location.origin
      });
    } else {
      // console.log("No user signed in")
      this.$router.push('/login')
    }

    // console.log("[List] mounted, with param: ", this.$route.params.id);
    // console.log('enabling toolbar')
    this.$store.commit('SET_ENABLETOOLBAR', true)

    // Fix Safari UI bug
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      setTimeout(this.safariUIFix, 10);
    }

    // add markers to map
    let geojson = {
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-77.032, 38.913]
        },
        properties: {
          title: 'Mapbox',
          description: 'Washington, D.C.'
        }
      },
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-122.414, 37.776]
        },
        properties: {
          title: 'Mapbox',
          description: 'San Francisco, California'
        }
      }]
    }
  },
  methods: {
    handleScroll () {
      // https://developer.mozilla.org/en-US/docs/Web/Events/scroll#Example
      if (!this.computing) {
        // use RAF to throttle function
        // use arrow function for "this" context
        // NB - avoid calls that will reflow the page...!
        window.requestAnimationFrame(() => {
          let off = Math.round(window.document.documentElement.scrollTop || document.body.scrollTop)
          this.buffer = this.baseBuffer + (Math.sin(off / 100) * 5)
          // reset
          this.computing = false
        })
        this.computing = true
      }
    },
    addNewItem() {
      this.$store.commit('ADD_NEW_ITEM')
    },
    updateItem(index, newValue) {
      this.$store.commit('UPDATE_ITEM', { index, newValue })
      // this.$store.dispatch('saveIfNeeded')
    },
    updateNote(newValue) {
      if (this.note != newValue) {
        this.$store.commit('UPDATE_NOTE', newValue)
      }
    },
    updateCode(newValue) {
      console.log('got update code')
      // if (this.code != newValue) {
      //   // this.$store.commit('UPDATE_CODE', newValue)
      // }
    },
    setItemFocus(index) {
      this.$store.commit('SET_ITEM_FOCUS', index)
    },
    setItemBlur(index) {
      this.$store.commit('SET_ITEM_BLUR', index)
    },
    deleteItem(index) {
      this.$store.commit('DELETE_ITEM', index)
    },
    new () {
      this.$router.push('/new').catch(err => {})
    },
    save () {
      // console.log('running save')
      this.$store.commit('SET_LIST_SAVING', true)
      NProgress.start()
      var listId = this.id
      var isNewList = this.createdAt === null
      this.$store.dispatch('save')
        .then(() => {
          if (isNewList) {
            this.$router.push('/maps/' + listId)
          } else {
            // console.log('not new list, continue...')
          }
        })
        .finally(() => {
          this.$store.commit('SET_LIST_SAVING', false)
          NProgress.done()
        })
    },
    print () {
      window.print()
      // console.log('needsSave is :', this.$store.getters.needsSave)
      // console.log('needsSave_currentList is :', this.$store.getters.needsSave_currentList)
      // console.log('needsSave_lists: ', this.$store.getters.needsSave_lists)
    },
    delete () {
      console.log('delete')
      // alert('delete coming soon!')
      this.$store.commit('SET_LIST_DELETING', true)
      this.$store.dispatch('deleteCurrentList')
        .then(() => {
          // this route will generate a new list if necessary
          this.$store.commit('SET_LIST_DELETING', false)
          this.$router.push('/maps')
        })
        .catch(() => {
          this.$store.commit('SET_LIST_DELETING', false)
        })
    },
    switchList (listIndex) {
      const listId = this.$store.state.lists[listIndex].id
      this.$router.push('/maps/' + listId).catch(err => {})
    },
    setType(listType) {
      this.type=listType
      if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        setTimeout(this.safariUIFix, 10)
      }
    },
    safariUIFix() {
      this.addNewItem()

      this.$nextTick(() => {
        // console.log('deleting on next tick...')
        let index = this.items.length - 1
        if (this.items[index].value === "") {
          this.deleteItem(index)
        }
      })
    },
    setMap(map) {
      console.log('setmap')
      this.map = map
      
      // this.map.on('zoom', () => {
      //   this.mapInfo.config.zoom = this.map.getZoom()
      // });

      // this.map.on('moveend', () => {
      //   let center = this.map.getCenter()
      //   this.mapInfo.config.latitude = center.lat
      //   this.mapInfo.config.longitude = center.lng
      // });
    },
    unsetMap() {
      console.log('unsetmap')
      this.map = null
    },
    onMapLoaded() {
      console.log("map loaded")
    }
  },
  beforeRouteEnter (routeTo, routeFrom, next) {
    // console.log('BEFORE ROUTE ENTER')
    // store.commit('SET_SHOWTOOLBAR', true)
    const userSession = store.state.blockstack.userSession
    if (userSession) {
      if (!store.state.blockstack.userSession.isUserSignedIn()) {
        console.log('user not signed in')
        next({
          path: '/'
        })
        return
      }
    } else {
      next('/')
      return
    }

    if (!routeTo.params.id) {
      next() // Handle case for new list
      return
    }

    // Load existing list
    store.dispatch('loadLists')
    store.dispatch('loadList', routeTo.params.id)
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        if (listData != null) {
          next()
          return
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })
  },
  beforeRouteUpdate (routeTo, routeFrom, next) {

    const userSession = store.state.blockstack.userSession
    if (userSession) {
      if (!store.state.blockstack.userSession.isUserSignedIn()) {
        console.log('user not signed in')
        next({
          path: '/'
        })
        return
      }
    } else {
      next('/')
      return
    }

    store.dispatch('loadLists')
    store.dispatch('loadList', routeTo.params.id)
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        if (listData != null) {
          next()
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })
  },
  // beforeRouteLeave (routeTo, routeFrom, next) {
  //   console.log('BEFORE ROUTE LEAVE')
  //   store.commit('SET_SHOWTOOLBAR', false)
  //   next()
  // },
  components: {
    NoteEditor,
    EditableTitle,
    SingleLineInput,
    CodeEditor,
    'vue-mapbox-map': VueMapboxMap,
    VueMapboxFeature,
    PlacemarkEditor,
    ShareBar,
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglPopup,
    MglMarker,
    MglScaleControl
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Lexend+Deca&display=swap');
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700');

/* for vue-mapbox */
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.53.0/mapbox-gl.css");

/* for vue-mapbox-map */
@import url("https://api.mapbox.com/mapbox-gl-js/v1.3.1/mapbox-gl.css");

#map-container {
  /* position: relative;
  top: 0;
  left: 0; */
  /* height: 500px;
  width: 500px; */
  height:100%;
  width:100%;
  min-height:300px;
  border-radius:15px;
}

h1 {
  /* font-family: 'Lexend Deca', sans-se<p></p>rif; */
}


.list {
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  /* margin: 8px */
  margin-left: 5px;
  margin-right: 8px;
}

.shad-dark-bg {
  -webkit-box-shadow: 6px 6px 5px black;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow:    6px 6px 5px black;  /* Firefox 3.5 - 3.6 */
  box-shadow:         6px 6px 5px black;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

.shad {
  -webkit-box-shadow: 6px 6px 5px gray;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow:    6px 6px 5px gray;  /* Firefox 3.5 - 3.6 */
  box-shadow:         6px 6px 5px gray;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

li {
  font-size:32px;
}
li div {
  font-size:32px;
  /* font-weight:450; */
  /* font-family: 'Lexend Deca', sans-serif; */
}

.listitem {
  /* border: 1px dotted gray; */
}

.addbutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
  background-color: whitesmoke;
}

.addbutton:hover {
  background-color: lightgray;
}

.notebutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
}

.notebutton:hover {
  background-color: whitesmoke;
}

.notebox {
  
  margin-left:-10px;
  margin-right:-10px
}

.active {
  background: green;
  border: 1px dotted blue;
  display:inline;
}

.sli:hover + .deletebutton {
  display: block
}

.deletebutton {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:40px;
    height:100%;
    margin-left: 5px;
    /* display:none; */
    /* border:1px solid gray; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.marker {
  background-image: url('../assets/images/mapbox-icon.png');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}

@media screen and (min-width: 500px) {

    .list {
      background-color: white;
      border-radius: 15px;
      padding: 50px;
      margin: 15px
    }

    .notebox {
      margin-left: 0px
    }
}

</style>

<style>

.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {
  border-bottom-color: rgba(0, 0, 0, 0) !important;
}
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {
  border-top-color: rgba(0, 0, 0, 0) !important;
}
.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
  border-right-color: rgba(0, 0, 0, 0) !important;
}
.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
  border-left-color: rgba(0, 0, 0, 0) !important;
}

/* .mapboxgl-popup-tip {
  background: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
} */

.mapboxgl-popup {
  /* border-radius: 15px; */
  /* font: 400 15px/22px 'Source Sans Pro', 'Helvetica Neue', Sans-serif; */
  /* background: blue; */
  color: white;
  padding:0px !important;
  margin: 0px !important;
}

.mapboxgl-popup-content {
  padding: 4px !important;
  padding-right: 8px !important;
  padding-left: 8px !important;
  margin: 0px !important;
  font-size:1.2em;
  border-radius:10px !important;
  background: black !important;
  max-width: 150px;
  max-height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* .mapboxgl-popup-content-wrapper {
  padding: 1%;
  background:red !important;
} */

</style>